<template>
    <div class='container d-flex'>
        <!-- 排序 -->
        <div class="sort">
            <ul class="list-unstyled mb-0 d-flex">
                <li @click="newsort()" :class="sorts == 1 ? 'active' : ''"><span>最新上架</span></li>
                <li @click="discountsort()" :class="sorts == 2 ? 'active' : ''"><span>折扣商品</span></li>
                <li @click="sort('asc')" :class="sorts == 3 ? 'active' : ''"><span>價格升序</span></li>
                <li @click="sort('desc')" :class="sorts == 4 ? 'active' : ''"><span>價格降序</span></li>
            </ul>
        </div>
        <span style="color: red;">
            💡點選圖片查看商品詳情💡
        </span>
        <!-- item -->
        <ul class="list-unstyled d-grid shop-item mb-0">
            <li v-for="item, index in sort_all_list" style="position: relative;">
                <div @click="godetails(item.oig_id)" style="cursor: pointer ; ">
                    <ImageLoader :key="index" :imageSrc=" isMobile ? item.images_mobile : item.images" class="img" :altText="item.group_name" />
                </div>
                <div style="padding:10px;">
                    <div class="name">{{ item.group_name }}</div>
                    <div v-if="item.price_original_max - item.price_max != 0" class="price">
                        <del style="font-size: 12px;">${{ item.price_original_max | formatNumberToqff }} </del>
                        <div class="special" ><span style="font-size: 12px;"></span>${{
                            item.price_min | formatNumberToqff }}
                        </div>
                    </div>
                    <div class="price" style="min-height: 48px;" v-else>
                        <div class="special"><span style="font-size: 12px;"></span>${{ item.price_original_max |
                            formatNumberToqff }}
                        </div>
                    </div>
                    <div
                        :style="[{ textAlign: 'center' }, { bottom: '0px' }, { width: '100%' }, { position: 'relative' }]">
                        <!-- <span @click.stop="getdetails(item.oig_id)" data-bs-toggle="modal"
                            :data-bs-target="'#m' + item.oig_id">立即訂購👉</span> -->
                        <div class="icon" data-bs-toggle="modal" @click.stop="getdetails(item.oig_id)"
                            :data-bs-target="'#m' + item.oig_id">
                            <i class="icon-new_cart"></i>
                        </div>
                    </div>
                </div>
                <shopmodal :value="item" ref="details"></shopmodal>
            </li>
        </ul>
        <!-- 页码 -->
        <div class="d-flex justify-content-center align-items-center page">
            <ul class="pt_pagination_list d-flex align-items-center list-unstyled mb-0" style="">

            </ul>
        </div>
    </div>
</template>
<script>
import $ from 'jquery'
import shopmodal from '@/components/modal/Shop.vue'
import ImageLoader from '@/components/Image_loading.vue'
import numeral from "numeral";
import { mapState } from 'vuex';
export default {
    components: { shopmodal, ImageLoader },
    data() {
        return {
            id: '',
            sorts: 1,
            isMobile: false,
            webmeta: {
                og_title: '',
                commodity_title: '',
                commodity_description:''
            }
        };
    },
    computed: {
        ...mapState('commodity', ['category_list', 'sort_category_list', 'all_list', 'sort_all_list']),
        ...mapState('header', ['getfooter', 'cate', 'website', 'getnav', 'seo']),
        computedOgTitle() {
            return this.seo.og_title || '';
        },
        computedTitle() {
            return this.seo.commodity_title || '';
        },
        computedDescription(){
            return this.seo.commodity_description || '';
        }
    },
    metaInfo() {
        return {
            title: this.webmeta.commodity_title || this.webmeta.og_title,
            meta: [
                { vmid: 'description', name: 'description', content: this.webmeta.commodity_description },
            ]
        }
    },
    watch: {},
    filters: {
        formatNumberToqff(val) {
            return numeral(val).format('0,0');
        }
    },
    methods: {
        godetails(e) {
            this.$store.dispatch('commodity/getdesignated_product', e).then(response => {
                this.$router.push({
                    path: `/details/${e}`,
                }).catch(err => { })
            });
        },
        getdetails(e) {
            this.$refs.details.forEach(element => {
                if (element.value.oig_id == e) {
                    element.getitem();
                }
            })
        },
        // 價格排序
        sort(e) {
            // console.log(e);
            if (e == 'desc') {
                this.sorts = 4;
            } else {
                this.sorts = 3;
            }
            let x = this.all_list
            this.$store.commit('commodity/set_sort_all_list', _.orderBy(x, ['price_max'], [e]))
        },
        // 最新上架
        newsort() {
            this.sorts = 1;
            this.$store.commit('commodity/set_sort_all_list', this.all_list)
        },
        // 折扣商品
        discountsort() {
            this.sorts = 2;
            let x = this.all_list;
            let y = [];
            let z = [];
            x.forEach(element => {
                if (element.price_original_max - element.price_max != 0) {
                    y.push(element)
                } else {
                    z.push(element)
                }
            });
            this.$store.commit('commodity/set_sort_all_list', y.concat(z))

        }
    },
    created() {
        this.webmeta.og_title = this.computedOgTitle;
        this.webmeta.commodity_title = this.computedTitle;
        this.webmeta.commodity_description = this.computedDescription;
    },
    mounted() {

        if (window.innerWidth > 600) {
            this.isMobile = false;
        } else {
            this.isMobile = true;

        }

        this.sorts = 1;
        this.$store.dispatch('commodity/getall').then(() => {
        })
        try {
            $('#navbar-nav')[0].childNodes.forEach(element => {
                $(element).removeClass('active')
                if (element.childNodes[0].childNodes[0].innerText == this.$route.params.name) {
                    $(element).addClass('active')
                }
            });
        } catch (error) {

        }
    },
    uodata() {
    },
}
</script>
<style lang='scss' scoped src="./index.scss"></style>